Ext.define('SA.view.DeleteProjectPopup', {
    alias: 'widget.delete-project-popup',
    extend: 'SA.view.SimpleContainer',

    autoShow: true,
    cls: 'sa-delete-project-popup',
    floating: true,
    modal: true,
    plugins: 'sa-viewport-constrained-auto-center',

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-delete-project-popup-header',

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-delete-project-popup-title',
                    html: 'Delete Project?'
                }, {
                    xtype: 'close-button'
                }
            ]
        }, {
            xtype: 'component',
            cls: 'sa-delete-project-popup-body',

            html: [
                '<svg class="sa-delete-project-popup-warning-svg"><use href="#sa-icon-warning"></use></svg>',
                '<div>Are you sure? Deleted projects cannot be recovered.</div>'
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-delete-project-popup-footer',

            items: [
                {
                    xtype: 'sa-button',
                    cls: 'sa-delete-project-popup-delete-btn',
                    text: 'Delete',

                    handler() {
                        var me = this.up('delete-project-popup');

                        me.destroy();

                        SA.AppController.deleteProject(me.project);
                    }
                }, {
                    xtype: 'sa-button',
                    text: 'Cancel',
                    ui: 'primary',

                    handler() {
                        this.up('delete-project-popup').destroy();
                    }
                }
            ]
        }
    ]
});